// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"72":"cade53a5","453":"bfd56f49","958":"de0352df"}[chunkId] + ".chunk.js";
};